// src/hooks/useInsights.js
import { useQuery } from "@tanstack/react-query";
import drEasyApi from "../Api/Customapi";

export const useInsights = () => {
  return useQuery({
    queryKey: ["dashboard-insights"],
    queryFn: async () => {
      try {

        const response = await drEasyApi.get("/api/Doctor/insights");
        return response.data;
      } catch (err) {
        if (err.response.status == 403) {
          window.location.href = "/sub"; // Adjust auth path as needed

        }
      }


    },
    staleTime: 1000 * 60 * 3, // 5 minutes
    refetchOnWindowFocus: true,
    refetchInterval: 1000 * 60 * 5, // Refetch every 10 minutes in background

  });
};
